!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("formik"), require("@material-ui/core"), require("@material-ui/icons/CloudUpload"), require("@material-ui/icons/AttachFile"), require("react-dropzone"), require("@material-ui/core/RootRef"), require("blueimp-load-image")) : "function" == typeof define && define.amd ? define(["exports", "react", "formik", "@material-ui/core", "@material-ui/icons/CloudUpload", "@material-ui/icons/AttachFile", "react-dropzone", "@material-ui/core/RootRef", "blueimp-load-image"], t) : t((e = e || self)["file-field"] = {}, e.React, e.formik, e.core, e.CloudUploadIcon, e.AttachFileIcon, e.reactDropzone, e.RootRef, e.loadImage);
}(this, function (e, t, r, n, a, i, o, l, c) {
  "use strict";

  var u = "default" in t ? t.default : t;
  a = a && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a, i = i && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i, l = l && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l, c = c && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c;

  var _d = function d() {
    return (_d = Object.assign || function (e) {
      for (var t, r = 1, n = arguments.length; r < n; r++) for (var a in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);

      return e;
    }).apply(this, arguments);
  };

  function p(e, t) {
    var r = {};

    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var a = 0;

      for (n = Object.getOwnPropertySymbols(e); a < n.length; a++) t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    }

    return r;
  }

  var m = function m(e) {
    var r = t.useState(),
        n = r[0],
        a = r[1];
    return t.useLayoutEffect(function () {
      var t = new FileReader();
      return e || a(void 0), e && (t.onloadend = function () {
        "string" == typeof t.result && c(t.result, function (e) {
          e.toDataURL && a(e.toDataURL("image/png"));
        }, {
          orientation: !0,
          canvas: !0
        });
      }, t.readAsDataURL(e)), function () {
        t.abort();
      };
    }, [e]), n;
  },
      s = function s(e) {
    var t = e.file,
        r = m(t);
    return u.createElement(n.Grid, {
      item: !0,
      xs: !0,
      key: t.name,
      style: {
        padding: "16px"
      }
    }, u.createElement(n.Grid, {
      container: !0,
      justify: "center",
      alignItems: "center",
      style: {
        width: "100%",
        height: "100%"
      }
    }, u.createElement(n.Grid, {
      item: !0
    }, r && u.createElement("img", {
      src: r,
      alt: "upload preview",
      width: "100%",
      style: {
        minWidth: "120px",
        maxWidth: "360px"
      }
    }))));
  },
      f = r.connect(function (e) {
    var c = e.name,
        m = e.required,
        f = e.fileTypes,
        y = e.label,
        g = e.ButtonProps,
        h = e.component,
        b = e.children,
        v = e.preview,
        E = void 0 !== v && v,
        x = e.childrenPosition,
        w = void 0 === x ? "top" : x,
        O = e.onClick,
        k = e.formik,
        j = k.setFieldValue,
        R = k.values,
        P = k.errors,
        G = k.touched,
        F = k.validateOnChange,
        q = e.numberLimit,
        I = e.disabled;
    if (E && b) throw new Error("FileField cannot render both children when preview is enabled");

    var C = t.useCallback(function (e) {
      e && e.length > 0 && j(c, e.slice(0, q));
    }, [q]),
        L = o.useDropzone({
      onDrop: C
    }),
        D = L.getRootProps,
        T = L.getInputProps,
        U = D({
      onClick: function onClick(e) {
        O && O(e), S();
      }
    }),
        z = U.ref,
        A = p(U, ["ref"]),
        B = t.useRef(null),
        S = t.useCallback(function () {
      B && B.current && B.current.click();
    }, [B]),
        W = n.makeStyles({
      root: {
        display: "inline-block",
        "&:hover": {
          cursor: "pointer"
        }
      }
    })(),
        _ = r.getIn(R, c),
        H = (r.getIn(G, c) || F) && r.getIn(P, c),
        M = _ && _.length > 0 && /^[i][m][a][g][e](.*)/.test(_[0].type);

    return u.createElement(l, {
      rootRef: z
    }, u.createElement("div", _d({}, A, {
      className: W.root
    }), h ? u.createElement("span", null, h) : u.createElement(u.Fragment, null, u.createElement(n.Button, _d({
      tabIndex: -1,
      "aria-label": "upload file",
      variant: "outlined",
      disabled: I
    }, g, {
      style: _d(_d({
        padding: 0
      }, g && g.style), {
        textTransform: _ ? "none" : void 0
      })
    }), u.createElement(n.Grid, {
      container: !0,
      justify: "center",
      direction: "column"
    }, b && "top" === w ? u.createElement(n.Grid, {
      item: !0,
      xs: 12
    }, b) : null, E && M ? u.createElement(n.Grid, {
      item: !0
    }, u.createElement(n.Grid, {
      container: !0,
      direction: "row",
      justify: "space-evenly",
      spacing: 1
    }, _ && _.map(function (e) {
      return u.createElement(s, {
        file: e,
        key: e.name
      });
    }))) : null, _ ? u.createElement(n.Grid, {
      item: !0,
      style: {
        padding: "8px"
      }
    }, _.map(function (e) {
      return u.createElement(n.Grid, {
        container: !0,
        direction: "row",
        key: e.name,
        style: {
          width: 300
        }
      }, u.createElement(n.Grid, {
        item: !0,
        style: {
          marginRight: 8
        }
      }, u.createElement(i, null)), u.createElement(n.Grid, {
        item: !0,
        xs: 10
      }, u.createElement(n.Typography, {
        noWrap: !0,
        align: "left"
      }, e.name)));
    })) : u.createElement(n.Box, {
      display: "flex",
      minHeight: "24px",
      padding: "6px 16px 6px 16px"
    }, u.createElement(n.Typography, {
      style: {
        wordBreak: "break-all"
      }
    }, y), u.createElement(a, {
      style: {
        marginLeft: 12
      }
    })), b && "bottom" === w ? u.createElement(n.Grid, {
      item: !0,
      xs: 12
    }, b) : null)), H ? u.createElement(n.Typography, {
      display: "block",
      style: {
        marginTop: 3,
        marginLeft: 3
      },
      variant: "caption",
      color: "error"
    }, H) : null), u.createElement("input", _d({
      required: m
    }, T(), {
      accept: f,
      style: {
        height: "1px",
        width: "1px"
      },
      ref: B,
      disabled: I
    }))));
  }),
      y = r.connect(function (e) {
    var t = e.name,
        r = p(e, ["name"]);
    return u.createElement(f, _d({
      name: t
    }, r));
  });

  e.FileField = y, e.useFilePhoto = m, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});